// 广告监听
const advListen = (para) => {
    console.log('start');
    console.log(para);
    // 若广告加载超时 上传谷歌分析
    if (para === 'loadTimeout') {
        window.law_template = 1;
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        gtag('event', "Load_Timeout", {
            "loadTimeout": 'adv loadTimeout'
        });
        console.log('Load timeout!');
        return;
    };


    var pageAdvNode = document.querySelector('#adv_1 iframe');
    console.log(pageAdvNode);
    if (pageAdvNode) {
        console.log('iframe loadding');
        window.law_template = 1;
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }

        // 广告1
        var pageAdv1 = document.querySelector('#adv_1 iframe');
        // 广告2
        var pageAdv2 = document.querySelector('#adv_2 iframe');

        // window.law_collection = 1;
        // 广告加载 
        if (window.law_collection == 1) {
            if (para >= 15) {
                // 广告加载超过15秒 上传谷歌分析
                gtag('event', 'Adv_Timeout', {
                    "AdvTimeout": para + 's'
                });
                console.log('AdvTimeout!');
            } else if (pageAdvNode.getBoundingClientRect().height > 50) {
                // 广告加载完成 上传谷歌分析
                gtag('event', 'load_Adv', {
                    "timeDifference": para + 's'
                });
                console.log('load-gtag!');
            } else {
                // 广告无展示 上传谷歌分析
                gtag('event', 'Adv_NoDisplay', {
                    "NoDisplay": para + 's'
                });
                console.log('No_display!');
            }
        }

        var gtag_js = function () {
            gtag('event', 'click_Adv', {
                "click_Adv": 'true'
            });
            console.log('click-gtag!');
        }

        // 广告添加监听
        if (window.law_collection == 1) {
            // iframe 实现点击功能
            var IframeOnClick = {
                resolution: 200,
                iframes: [],
                interval: null,
                Iframe: function () {
                    this.element = arguments[0];
                    this.cb = arguments[1];
                    this.hasTracked = false;
                },
                track: function (element, cb) {
                    this.iframes.push(new this.Iframe(element, cb));
                    if (!this.interval) {
                        var _this = this;
                        this.interval = setInterval(function () {
                            _this.checkClick();
                        }, this.resolution);
                    }
                },
                checkClick: function () {
                    if (document.activeElement) {
                        var activeElement = document.activeElement;
                        for (var i in this.iframes) {
                            if (activeElement === this.iframes[i].element) { // user is in this Iframe  
                                if (this.iframes[i].hasTracked == false) {
                                    this.iframes[i].cb.apply(window, []);
                                    this.iframes[i].hasTracked = true;
                                }
                            } else {
                                this.iframes[i].hasTracked = false;
                            }
                        }
                    }
                }
            }

            if (pageAdv1) {
                IframeOnClick.track(pageAdv1, gtag_js);
            }

            if (pageAdv2) {
                IframeOnClick.track(pageAdv2, gtag_js);
            }

        }
        console.log('end!');
    }
}

/* // 广告移除监听
const listen_removeAdv = () => {
    var gtag_js;
    console.log('listen_removeAdv');
    window.law_template = 1;
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }

    // 广告1
    var pageAdv1 = document.querySelector('#adv_1 iframe');
    // 广告2
    var pageAdv2 = document.querySelector('#adv_2 iframe');

    if (window.law_collection = 1) {
        gtag_js = function () {
            gtag('event', 'click_Adv', {
                "click_Adv": 'true'
            });
            console.log('click adv !!!');
        }
    }


    if (window.law_collection = 1) {

        if (pageAdv1) {
            pageAdv1.removeEventListener('click', gtag_js);
        }

        if (pageAdv2) {
            pageAdv2.removeEventListener('click', gtag_js);
        }
    }
} */

const iframeLoad = (para) => {
    let timer;
    let timeStep;
    let second = 0;
    // 超过十秒停止
    timeStep = setInterval(() => {
        second += 1;
        console.log("second:" + second);
        if (second == 10) {
            clearInterval(timer);
            clearInterval(timeStep);
            // 超时
            advListen('loadTimeout');
            return;
        }
    }, 1000)
    // 查询到iframe执行谷歌分析
    timer = setInterval(() => {
        var pageAdvNode = document.querySelector('#adv_1 iframe');
        if (pageAdvNode) {
            clearInterval(timer);
            clearInterval(timeStep);
            var loadTime = new Date().getTime();
            pageAdvNode.onload = () => {
                var iframeLoadSecond = new Date().getTime();
                let timeDifference = (iframeLoadSecond / 1000 - loadTime / 1000).toFixed(2);
                setTimeout(() => {
                    advListen(timeDifference);
                }, 500);
                return;
            }
        }
    }, 50);
}

export { iframeLoad };